import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { FORM_STYLES } from "../constants";
import { PageOneFormData } from "../models";

export const WristbandInfo = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageOneFormData>();

  return (
    <Grid md={3} xs={12} sx={{ padding: "0px", paddingRight: "20px" }}>
      <Box
        sx={{
          border: FORM_STYLES.sectionBorder,
          borderRadius: FORM_STYLES.sectionBorderRadius,
          padding: FORM_STYLES.sectionPadding,
        }}
      >
        <Grid
          sx={{
            backgroundColor: FORM_STYLES.titleBackgroundColor,
            color: FORM_STYLES.titleColor,
            borderRadius: FORM_STYLES.titleBorderRadius,
          }}
        >
          <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
            {t("adult-patient-assessment.wristband")}
          </ByzMuiTypography>
        </Grid>
        <Controller
          name="wristbandInfo"
          control={control}
          render={({ field }) => (
            <ByzMuiRadioButton
              {...field}
              typographyText="adult-patient-assessment.exists-check-info,adult-patient-assessment.not-present-ensure-attachment"
              layout="column"
              border="none"
              fontSize={16}
              textAlign="left"
              maxWidth="100%"
            />
          )}
        />
      </Box>
    </Grid>
  );
};
